export default "__VITE_ASSET__BwLEJPnl__"